module.exports = __webpack_public_path__ + "933cbe344d9c2b4d08f8ba07f2db64f7.png";